export default "__VITE_ASSET__BBV6ufg1__"